import { getUserProperties } from '@thoughtspot/session-service';
export function getSavedOnboardingSelections(functionOptions, industryOptions, isMTService, savedRole) {
    const userProperties = getUserProperties();
    const savedFunction = isMTService
        ? savedRole?.function
        : userProperties?.function;
    const savedIndustry = isMTService
        ? savedRole?.industry
        : userProperties?.industry;
    return {
        function: savedFunction &&
            functionOptions.some(opt => opt.id === savedFunction)
            ? savedFunction
            : '',
        industry: savedIndustry &&
            industryOptions.some(opt => opt.id === savedIndustry)
            ? savedIndustry
            : '',
    };
}
//# sourceMappingURL=utils.js.map